import { useState, useEffect, useRef } from "react";
import type { FC } from "react";
import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Card,
  Backdrop,
  CircularProgress,
  CardContent,
  MenuItem,
  Select,
  Divider,
  Tooltip,
  Skeleton,
  IconButton,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import DeleteIcon from "@material-ui/icons/Delete";
import Save from "@material-ui/icons/Save";
import { useSnackbar } from "notistack";
import DataTable from "src/components/ui-components/tabletreeview/dataTable";
// import useSettings from "src/hooks/useSettings";
import usePermission from "src/hooks/usePermission";
import ChevronRightIcon from "src/icons/ChevronRight";

import {
  getConfigUserRolePermissions,
  getConfigUserGroups,
  getConfigUserGroupRoleWithPermissions,
  deleteConfigUserGroup,
  insertConfigUserGroupPermissionMapping,
  updateConfigUserGroupPermissionMapping,
} from "src/redux/account/connectionServices";

const RolesAndPermissions: FC = () => {
  const ref = useRef(null);
  const isMounted = useRef(true);
  //   const { settings } = useSettings();
  const [isLoading, setIsLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const PermissionContext = usePermission();
  const { enqueueSnackbar } = useSnackbar();
  const [showDlteConf, setShowDlteConf] = useState(false);
  const [showDialoge, setShowDialoge] = useState(false);
  const [slctedList, setSlctedList] = useState([]);
  const [selectedRole, setSelectdRole] = useState();
  const [allChecked, setAllChecked] = useState<number>();
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [configUserGroupKey, setRoleKey] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [roleList, setRoleList] = useState<Array<any>>([]);
  const [treeTableList, setTreeTableList] = useState([]);
  const role = JSON.parse(localStorage.getItem("userDetails"))?.configUserGroup;
  const userEmail = JSON.parse(localStorage.getItem("userDetails"))?.email;

  const setChildLeght = async () => {
    const list = [];
    const arrayFunc = (treeTableLists) => {
      /* eslint-disable-next-line */
      treeTableLists.map((permission) => {
        /* eslint-disable-next-line */
        permission?.data?.permissions.map((item) => {
          if (item.configUserRolePermissionKey)
            list.push(item.configUserRolePermissionKey);
        });
        if (permission?.children?.length > 0) {
          arrayFunc(permission?.children);
        }
      });
    };
    arrayFunc(treeTableList);
    setAllChecked(list.length);
  };

  const updateSlcted = (value) => {
    setSlctedList(value);
  };

  const fetchConfigUserRolePermissions = () => {
    getConfigUserRolePermissions().then((data) => {
      if (isMounted.current) {
        const filteredData = data.filter((item) => {
          return item.data.featureName !== "Roles & Permission Management";
        });
        const updateHeightsAndFilterChildren = (item) => {
          if (item?.children) {
            item.children = item.children
              .map((childItem) => {
                childItem.height = 39;
                return updateHeightsAndFilterChildren(childItem);
              })
              .filter(
                (childItem) =>
                  childItem.data.featureName !== "Roles & Permission Management"
              );
          }
          return item;
        };
        const updatedData = filteredData.map(updateHeightsAndFilterChildren);
        setTreeTableList(updatedData);
      }
    });
  };

  const fetchConfigUserGroupRoleWithPermissions = (key) => {
    setFetching(true);
    getConfigUserGroupRoleWithPermissions(key)
      .then((data) => {
        setFetching(false);
        const list = [];
        const permissionList = [];
        /* eslint-disable-next-line */
        data[0].permissions.map((item) => {
          permissionList.push(item.permission);
          list.push(item.configUserRolePermissionKey);
        });
        setSlctedList(list);
        if (data[0]?.configUserGroup === role) {
          PermissionContext.setPermission(permissionList);
          localStorage.setItem("permission", JSON.stringify(permissionList));
        }
      })
      .catch(() => setFetching(false));
  };

  const fetchRoleList = (userEmail) => {
    getConfigUserGroups(userEmail)
      .then((data) => {
        setRoleList(data);
        setIsLoading(false);
        fetchConfigUserRolePermissions();
        if (data.length > 0) {
          const defaultRole = data[0];
          ref?.current?.setFieldValue(
            "configUserGroup",
            defaultRole.configUserGroup
          );
          ref?.current?.setFieldValue(
            "configUserGroupKey",
            defaultRole.configUserGroupKey
          );
          setRoleKey(defaultRole.configUserGroupKey);
          fetchConfigUserGroupRoleWithPermissions(
            defaultRole.configUserGroupKey
          );
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getConfigUserGroups(userEmail)
      .then((data) => {
        setRoleList(data);
        setIsLoading(false);
        fetchConfigUserRolePermissions();
      })
      .catch(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setChildLeght();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeTableList]);

  const updateNameDesc = (key) => {
    const data = roleList.find((element) => key === element.configUserGroupKey);
    ref?.current?.setFieldValue("configUserGroup", data?.configUserGroup);
    setSelectdRole(data?.configUserGroup);
    fetchConfigUserGroupRoleWithPermissions(key);
    return data?.configUserGroup;
  };

  const handleConfirmClose = () => {
    setShowDlteConf(false);
  };

  const handleDeleteAgree = () => {
    setShowDlteConf(false);
    deleteConfigUserGroup(configUserGroupKey)
      .then(() => {
        fetchRoleList(userEmail);
        setRoleKey("");
        setEditMode(false);
        setSlctedList([]);
        ref?.current?.resetForm({
          values: {
            configUserGroup: "",
          },
        });
        enqueueSnackbar("User Group Deleted.", {
          anchorOrigin: {
            horizontal: "right",
            vertical: "top",
          },
          variant: "success",
        });
      })
      .catch((err) => {
        if (err && err.errors) {
          Object.entries(err.errors).forEach(([, errMsg], index) => {
            enqueueSnackbar(errMsg[0], {
              anchorOrigin: {
                horizontal: "right",
                vertical: "top",
              },
              variant: "error",
            });
          });
        } else {
          enqueueSnackbar(err.title || err.message, {
            anchorOrigin: {
              horizontal: "right",
              vertical: "top",
            },
            variant: "error",
          });
        }
      });
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", pb: 4 }}>
        <Container maxWidth={false}>
          <Grid
            alignItems="center"
            sx={{ my: 2 }}
            container
            justifyContent="space-between"
          >
            <Grid item>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ChevronRightIcon fontSize="small" />}
              >
                <Link
                  color="textPrimary"
                  component={RouterLink}
                  to=""
                  variant="h5"
                >
                  Permissions
                </Link>
                <Typography color="textPrimary" variant="h5">
                  Roles and Permission Management
                </Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
            }}
          >
            <Container maxWidth={false}>
              <Dialog
                open={showDialoge}
                onClose={handleConfirmClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText
                    style={{ marginBottom: -5 }}
                    id="alert-dialog-description"
                  >
                    It looks like you have been editing something. If you leave
                    before saving, your changes will be lost.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setShowDialoge(false);
                    }}
                    color="primary"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      setShowEditPanel(true);
                      setRoleKey("");
                      setEditMode(false);
                      setSlctedList([]);
                      ref?.current?.resetForm({
                        values: {
                          configUserGroup: "",
                          configUserGroupKey: "",
                        },
                      });
                      fetchConfigUserRolePermissions();
                      setShowDialoge(false);
                    }}
                    color="primary"
                    autoFocus
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={showDlteConf}
                onClose={handleConfirmClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure to delete this User Group.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleConfirmClose} color="primary">
                    Cancel
                  </Button>
                  <Button onClick={handleDeleteAgree} color="primary" autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
              <Box sx={{ my: 3, position: "relative" }}>
                <Grid container spacing={2}>
                  <Grid item md={12} xs={12}>
                    <Card>
                      <CardContent sx={{ p: 0 }}>
                        <Backdrop style={{ zIndex: 99 }} open={fetching}>
                          <CircularProgress color="primary" />
                        </Backdrop>
                        {!isLoading &&
                          (showEditPanel || roleList.length > 0) && (
                            <>
                              <Box sx={{ p: 2, pb: 0 }}>
                                <Box sx={{ my: 1 }}>
                                  <>
                                    <Formik
                                      innerRef={ref}
                                      initialValues={{
                                        configUserGroup: "",
                                        configUserGroupKey: "",
                                      }}
                                      validationSchema={Yup.object().shape({
                                        configUserGroup: Yup.string()
                                          .max(255)
                                          .required(
                                            "User Group Name is required"
                                          ),
                                        configUserGroupKey: Yup.string()
                                          .max(255)
                                          .test(
                                            "configUserGroupKey",
                                            "Config User Group Type is required",
                                            (value, { createError }) => {
                                              if (!value && editMode) {
                                                return createError({
                                                  message:
                                                    "Config User Group Type is required",
                                                });
                                              }
                                              return true;
                                            }
                                          ),
                                      })}
                                      onSubmit={async (
                                        values,
                                        { setSubmitting }
                                      ): Promise<void> => {
                                        if (!editMode) {
                                          try {
                                            setFetching(true);
                                            insertConfigUserGroupPermissionMapping(
                                              {
                                                configUserRolePermissionKey:
                                                  slctedList.toString(),
                                                configUserGroupKey:
                                                  values.configUserGroupKey,
                                              }
                                            )
                                              .then((data) => {
                                                setFetching(false);
                                                if (data.status === 200) {
                                                  ref?.current?.resetForm({
                                                    values: {
                                                      configUserGroupKey:
                                                        data?.configUserGroupKey,
                                                    },
                                                  });
                                                  setRoleKey(
                                                    data.configUserGroupKey
                                                  );
                                                  setShowEditPanel(false);
                                                  setEditMode(true);
                                                  fetchRoleList(userEmail);
                                                  enqueueSnackbar(
                                                    "Permissions created successfully",
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "success",
                                                    }
                                                  );
                                                } else {
                                                  enqueueSnackbar(
                                                    "Something went wrong",
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    }
                                                  );
                                                }
                                                setSubmitting(false);
                                              })
                                              .catch((err) => {
                                                setFetching(false);
                                                if (err && err.errors) {
                                                  Object.entries(
                                                    err.errors
                                                  ).forEach(([, errMsg]) => {
                                                    enqueueSnackbar(errMsg[0], {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    });
                                                  });
                                                } else {
                                                  enqueueSnackbar(
                                                    err.title || err.message,
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    }
                                                  );
                                                }
                                                setSubmitting(false);
                                              });
                                          } catch (err) {
                                            enqueueSnackbar(
                                              "Something went wrong",
                                              {
                                                anchorOrigin: {
                                                  horizontal: "right",
                                                  vertical: "top",
                                                },
                                                variant: "error",
                                              }
                                            );

                                            setSubmitting(false);
                                          }
                                        } else {
                                          try {
                                            setFetching(true);
                                            updateConfigUserGroupPermissionMapping(
                                              {
                                                configUserRolePermissionKey:
                                                  slctedList.toString(),
                                                configUserGroupKey:
                                                  values.configUserGroupKey,
                                              }
                                            )
                                              .then((data) => {
                                                setFetching(false);
                                                if (selectedRole === role) {
                                                  PermissionContext.setPermission(
                                                    slctedList
                                                  );
                                                  localStorage.setItem(
                                                    "permission",
                                                    slctedList.toString()
                                                  );
                                                }
                                                if (data.status === 200) {
                                                  fetchRoleList(userEmail);
                                                  enqueueSnackbar(
                                                    "Permissions updated successfully",
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "success",
                                                    }
                                                  );
                                                } else {
                                                  enqueueSnackbar(
                                                    "Something went wrong",
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    }
                                                  );
                                                }
                                                setSubmitting(false);
                                              })
                                              .catch((err) => {
                                                setFetching(false);
                                                if (err && err.errors) {
                                                  Object.entries(
                                                    err.errors
                                                  ).forEach(([, errMsg]) => {
                                                    enqueueSnackbar(errMsg[0], {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    });
                                                  });
                                                } else {
                                                  enqueueSnackbar(
                                                    err.title || err.message,
                                                    {
                                                      anchorOrigin: {
                                                        horizontal: "right",
                                                        vertical: "top",
                                                      },
                                                      variant: "error",
                                                    }
                                                  );
                                                }
                                                setSubmitting(false);
                                              });
                                          } catch (err) {
                                            enqueueSnackbar(
                                              "Something Went Wrong",
                                              {
                                                anchorOrigin: {
                                                  horizontal: "right",
                                                  vertical: "top",
                                                },
                                                variant: "error",
                                              }
                                            );
                                            setSubmitting(false);
                                          }
                                        }
                                      }}
                                    >
                                      {({
                                        errors,
                                        handleChange,
                                        handleSubmit,
                                        setFieldValue,
                                        isSubmitting,
                                        touched,
                                        values,
                                      }): JSX.Element => (
                                        <form
                                          noValidate
                                          onSubmit={handleSubmit}
                                          autoComplete="off"
                                        >
                                          {!showEditPanel && (
                                            <Grid container spacing={2}>
                                              <Grid item md={6} xs={12}>
                                                <FormControl
                                                  fullWidth
                                                  variant="outlined"
                                                >
                                                  <InputLabel id="configUserGroupKeyLabel">
                                                    User Group
                                                  </InputLabel>
                                                  <Select
                                                    labelId="configUserGroupKeyLabel"
                                                    value={
                                                      values.configUserGroupKey
                                                    }
                                                    label="UserGroups"
                                                    onChange={(e) => {
                                                      const selectedValue =
                                                        e.target.value;
                                                      setFieldValue(
                                                        "configUserGroupKey",
                                                        selectedValue
                                                      );
                                                      fetchConfigUserRolePermissions();
                                                      setEditMode(true);
                                                      setRoleKey(selectedValue);
                                                      updateNameDesc(
                                                        selectedValue
                                                      );
                                                    }}
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          maxHeight: 400,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    {roleList.map(
                                                      (item, index) => {
                                                        if (
                                                          item.configUserGroup !==
                                                            "SuperAdmin" &&
                                                          item.configUserGroup !==
                                                            "Admin"
                                                        ) {
                                                          return (
                                                            <MenuItem
                                                              key={
                                                                item.configUserGroupKey
                                                              }
                                                              value={
                                                                item.configUserGroupKey
                                                              }
                                                            >
                                                              {
                                                                item.configUserGroup
                                                              }
                                                            </MenuItem>
                                                          );
                                                        }
                                                        return null;
                                                      }
                                                    )}
                                                  </Select>
                                                </FormControl>
                                              </Grid>
                                            </Grid>
                                          )}
                                          {!showEditPanel &&
                                            configUserGroupKey && (
                                              <Divider
                                                style={{
                                                  marginTop: 10,
                                                  marginBottom: 15,
                                                  marginLeft: -15,
                                                  marginRight: -15,
                                                }}
                                              />
                                            )}
                                          {(showEditPanel ||
                                            configUserGroupKey) && (
                                            <Grid container spacing={2}>
                                              <Grid
                                                item
                                                md={3}
                                                xs={12}
                                                style={{ display: "flex" }}
                                              >
                                                {/* <TextField
                                                                                        fullWidth
                                                                                        label="User Group Name *"
                                                                                        autoComplete="off"
                                                                                        helperText={touched.configUserGroup && errors.configUserGroup}
                                                                                        error={Boolean(touched.configUserGroup && errors.configUserGroup)}
                                                                                        name="configUserGroup"
                                                                                        onChange={handleChange}
                                                                                        value={values.configUserGroup}
                                                                                      /> */}
                                                <Typography
                                                  variant="body1"
                                                  style={{ marginTop: 10 }}
                                                >
                                                  User Group Name :{" "}
                                                  <b>
                                                    {values.configUserGroup}
                                                  </b>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                md={2}
                                                xs={12}
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Box
                                                  style={{
                                                    width: 110,
                                                    marginTop: 10,
                                                  }}
                                                >
                                                  <IconButton
                                                    sx={{ p: "5px" }}
                                                    onClick={() =>
                                                      setShowDlteConf(true)
                                                    }
                                                  >
                                                    <Tooltip title="Delete">
                                                      <DeleteIcon fontSize="medium" />
                                                    </Tooltip>
                                                  </IconButton>
                                                  <IconButton
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                    sx={{ p: "5px" }}
                                                  >
                                                    <Tooltip title="Save">
                                                      <Save fontSize="medium" />
                                                    </Tooltip>
                                                  </IconButton>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          )}
                                        </form>
                                      )}
                                    </Formik>
                                  </>
                                </Box>
                              </Box>
                              <Divider sx={{ mt: 1.5, mb: -3 }} />
                              <Box sx={{ mt: 0 }}>
                                {(showEditPanel || configUserGroupKey) &&
                                  treeTableList.length > 0 && (
                                    <DataTable
                                      treeTableList={treeTableList}
                                      slctedList={slctedList}
                                      allChecked={allChecked}
                                      updateSlcted={updateSlcted}
                                    />
                                  )}
                              </Box>
                            </>
                          )}
                        {isLoading && (
                          <>
                            <Grid container>
                              <Grid item md={6}>
                                <Skeleton sx={{ ml: 2, mr: 2, height: 90 }} />
                              </Grid>
                            </Grid>
                            <Grid container sx={{ mt: -2 }}>
                              <Grid item md={6}>
                                <Skeleton sx={{ ml: 2, mr: 2, height: 90 }} />
                              </Grid>
                              <Grid item md={6}>
                                <Skeleton sx={{ ml: 2, mr: 2, height: 90 }} />
                              </Grid>
                            </Grid>
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 80 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                            <Skeleton
                              sx={{ ml: 2, mr: 2, mt: -2, height: 60 }}
                            />
                          </>
                        )}
                        {!isLoading &&
                          !showEditPanel &&
                          roleList.length === 0 && (
                            <>
                              <Box
                                sx={{
                                  height: 200,
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography variant="h6" sx={{ pl: 0 }}>
                                  No data found!
                                </Typography>
                              </Box>
                            </>
                          )}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default RolesAndPermissions;
